import React from 'react';

import { InlineNodeRendererWrapper } from '@atlaskit/renderer/extension-renderer';

import { useIsSSROrHydrating } from '@confluence/ssr-utilities/entry-points/useIsSSROrHydrating.ts';

/**
 * Split out this component because createMacroExtensionHandler is not a React component
 */
export function PlaceholderAwareInlineNodeRendererWrapper({
	children,
	macroId,
}: {
	children: React.ReactNode;
	macroId: string;
}): React.JSX.Element {
	const renderServerPlaceholder = useIsSSROrHydrating();

	return (
		<InlineNodeRendererWrapper
			{...(renderServerPlaceholder
				? { ssrPlaceholder: macroId }
				: { ssrPlaceholderReplace: macroId })}
		>
			{children}
		</InlineNodeRendererWrapper>
	);
}
